import { useEffect } from "react";
import { ReactSession } from "react-client-session";
import { useNavigate } from "react-router-dom";
import useRefreshToken from "./useRefreshToken";
import axios from "axios";
const URL = process.env.REACT_APP_URL;

const useAxiosPrivate = () => {
  const navigate = useNavigate();
  const refresh = useRefreshToken();

  const accessToken = ReactSession.get("accessToken");

  const axiosPrivate = axios.create({
    baseURL: URL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
      },

      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        const message = error.response.data.detail;
        const code = error?.response?.data?.code;
        if (
          error.response.status === 401 &&
          message ===
            "Session expired. Another session is active for this user." &&
          code === "session_expired"
        ) {
          localStorage.clear();
          sessionStorage.clear();
          navigate("/");
        }
        if (
          error.response.status === 401 &&
          message === "Given token not valid for any token type"
        ) {
          const newAccessToken = await refresh();
          ReactSession.set("accessToken", newAccessToken);
          prevRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosPrivate(prevRequest);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [refresh, accessToken, axiosPrivate]);

  return axiosPrivate;
};

export default useAxiosPrivate;
